import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { User } from '../../models/user';

@Component({
    selector: 'user-avatar-group',
    templateUrl: './user-avatar-group.component.html',
    styleUrls: ['./user-avatar-group.component.scss'],
    standalone: false
})
export class UserAvatarGroupComponent {
    @Input() users: User[] = [];
    @Input() limit = 3;
    @Input() size: 'large' | 'xlarge' | 'normal' = 'normal';
    @ContentChild(TemplateRef) avatarTemplate: TemplateRef<any>;

    dialogVisible = false;

    get visibleUsers(): User[] {
        return this.users.slice(0, this.limit);
    }

    get overflowCount(): number {
        return this.users.length - this.limit;
    }

    get hasOverflow(): boolean {
        return this.overflowCount > 0;
    }
}
